var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 126,
    viewBox: "0 0 188 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.91 15.2998L144.65 43.9598L126.64 83.1898L119.17 42.0898L130.91 15.2998Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.551 45.7698L148.101 29.6398L148.721 64.6198L130.551 45.7698Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.97 46.4498L148.36 44.7098L148.1 29.6398L158.52 33.9498L163.97 46.4498Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.02 85.0598C126.02 85.0598 148.379 64.7298 148.719 64.6198C149.059 64.5098 130.56 45.7698 130.56 45.7698L126.02 85.0598Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2305 56.4198L130.38 45.8298L126.021 85.0598L99.2305 56.4198Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3301 97.7298L114.3 72.2098L126.02 85.0598L96.3301 97.7298Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38 45.8298L99.2305 56.4198V15.2998L130.38 45.8298Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.719 76.8403L178.599 68.3203L174.27 77.8803L184.719 76.8403Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.619 120.59C137.199 120.59 136.779 120.43 136.459 120.11L133.449 117.1C132.809 116.46 132.809 115.42 133.449 114.78C134.089 114.14 135.129 114.14 135.769 114.78L138.779 117.79C139.419 118.43 139.419 119.47 138.779 120.11C138.459 120.43 138.039 120.59 137.619 120.59Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.963 120.471L107.484 118.717L105.73 123.195L110.208 124.95L111.963 120.471Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66052 60.8601L1.65051 56.6201L0.980469 63.9401L7.66052 60.8601Z",
    stroke: "#38D9A9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2188 12.2402L33.1288 25.1502",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64 12.21L171.58 21.8",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.42 1.37988L86.5 27.4999",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.851 98.4397L143.891 80.6396",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.219 111.88L144.27 95.4502",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 36.5L78.5 8.5",
    stroke: "#38D9A9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5703 17.2499C48.5703 17.2499 54.6903 10.0599 49.3403 2.92994C49.3403 2.91994 43.2203 10.1099 48.5703 17.2499Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9395 75.37C61.9395 75.37 69.5095 83.63 67.1395 94.43C64.7795 105.23 54.4196 115.09 54.4196 115.09L29.9395 105.89L44.1595 12.09C44.1595 12.09 55.3595 13.51 56.9595 13.51C58.5595 13.51 63.3595 14.22 63.3595 14.22V17.06C63.3595 17.06 51.4195 19.9 49.5695 31.99C47.7195 44.08 53.4095 68.26 61.9395 75.37Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7198 18.49C47.7198 18.49 49.1398 4.27 36.3398 0C36.3398 0 34.9198 14.22 47.7198 18.49Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1106 49.82L43.7807 53.27C39.8407 58.18 51.9906 64 51.9906 64L48.9906 65.44C48.9906 65.44 29.2407 58.31 37.7707 49.78",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6311 86.75L46.3011 82.48C46.3011 82.48 44.8811 100.97 60.5211 108.08C60.5211 108.08 69.7611 101.68 67.6311 86.75Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5204 95.99L7.90039 98.12L28.5204 105.94",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.631 113.05L69.2009 123.25V121.78L55.301 113.36L50.161 110.25C50.161 110.25 49.141 83.9 34.921 86.75C20.701 89.59 26.161 110.25 26.161 110.25L33.491 112.34",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3301 108.08L75.5801 110.72V108.08L64.8002 102.97",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9901 13.51C51.9901 13.51 49.7501 17.07 54.4201 21.33",
    stroke: "#38D9A9",
    strokeWidth: 1.1419,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4897 66.84C70.7897 68.27 69.9797 68 71.8197 68.99C73.1697 69.72 76.5198 69.46 76.5198 69.46V71C76.5198 71 70.0498 72.53 68.1298 75.37C66.1998 78.21 67.6198 86.75 67.6198 86.75L60.5098 85.33L63.3497 69.47",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8496 51.9001L61.9396 57.93L63.9996 56.9501C63.9996 56.9501 56.4296 49.72 49.8596 49.05",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8311 70.4299C66.8311 70.4299 68.6811 63.9899 59.6211 62.5699C59.6211 62.5699 60.3511 69.7599 66.8311 70.4299Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7607 69.68C70.1529 69.68 70.4707 69.3621 70.4707 68.97C70.4707 68.5779 70.1529 68.26 69.7607 68.26C69.3686 68.26 69.0508 68.5779 69.0508 68.97C69.0508 69.3621 69.3686 69.68 69.7607 69.68Z",
    fill: "#087F5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5602 15.64C55.1953 15.64 55.7101 15.1251 55.7101 14.49C55.7101 13.8548 55.1953 13.34 54.5602 13.34C53.9251 13.34 53.4102 13.8548 53.4102 14.49C53.4102 15.1251 53.9251 15.64 54.5602 15.64Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.061 100.25V114.24L34.2109 117.32V102.44L37.061 100.25Z",
    fill: "#0CA678"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherRightImage);
export default __webpack_public_path__ + "static/media/otherRightImage.2d88aa1b4da534c7b66a7c571d275aac.svg";
export { ForwardRef as ReactComponent };